
import React, { useEffect, useState } from 'react';
import { Header, VpatList } from '../components';
import axios from 'axios'

const Vpat = () => {
  const [votes, setVotes] = useState([]);

  useEffect(() => {
    // const url = 'http://localhost:5000/api/vote'
    const url = 'https://mykura-nodejs-backend-fca8901da273.herokuapp.com/api/vote'
    axios.get(url)
    .then((res) => {
      if (res.data.data) setVotes(res.data.data)
    })
    .catch((err) => console.log(err))
  }, []);

  return (
    <div className='h-screen mx-1 flex flex-col items-center'>
      <Header pageView='Verifiable Paper Audit Trail' />
      <div className="w-full max-w-screen-md mt-8 px-4">
        <div className="bg-white rounded-lg overflow-hidden">
          <div className="w-full overflow-x-auto">
            <div className="shadow overflow-hidden sm:rounded-lg">
              <div className="w-full overflow-y-scroll h-[80vh]">
                <table className="w-full divide-y divide-gray-200 text-xs sm:text-base font-lato ">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="py-2 px-3 sm:px-6 text-left font-bold uppercase tracking-wider">
                        #
                      </th>
                      <th className="py-2 px-3 sm:px-6 text-left font-bold uppercase tracking-wider">
                        VPAT Ref
                      </th>
                      <th className="py-2 px-3 sm:px-6 text-left font-bold uppercase tracking-wider">
                        Candidate Selected
                      </th>
                      <th className="py-2 px-3 sm:px-6 text-left font-bold uppercase tracking-wider">
                        Vote Count
                      </th>
                    </tr>
                  </thead>
                  <tbody className=" bg-white ">
                    {votes.map((vote,i) => (
                      <tr key={i} className="hover:bg-gray-100">
                        <td className="py-2 px-3 sm:px-6">{i + 1}</td>
                        <td className="py-2 px-3 sm:px-6">{vote.vvpatRef}</td>
                        <td className="py-2 px-3 sm:px-6">{vote.candidateName}</td>
                        <td className="py-2 px-3 sm:px-6">{vote.voteCount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Vpat;